/**
 * Descarga un CSV en el cliente. Usa ; como separador (Excel CL) y BOM UTF-8.
 */
export function downloadCsv(filename, rows) {
  if (!rows || rows.length === 0) return;

  const cols = Object.keys(rows[0]);
  const escape = (v) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const header = cols.join(';');
  const body = rows.map((r) => cols.map((c) => escape(r[c])).join(';')).join('\r\n');
  const csv = `${header}\r\n${body}`;

  const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
